export default "/assets/images/logo-footer.svg?f6b022fe75e639066b12b4e95d7c61ca";